// This component should be used for changeable (editable) simple text cells (one-liners)
// and translatable text cells (address fields)

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { SimpleTextCellLocalStoreService } from './simple-text-cell-local-store.service';
import { MatIcon } from '@angular/material/icon';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-simple-text-cell',
    templateUrl: './simple-text-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [SimpleTextCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, NgClass, NgxSkeletonLoaderModule, MatIcon]
})
export class SimpleTextCellComponent extends AgCellRendererComponent {

  viewModel$ = this.localStore.viewModel$;

  constructor(protected localStore: SimpleTextCellLocalStoreService) {
    super(localStore);
  }
}
